import useSplitedTable from '../../../hooks/useSplitedTable';
import { Table } from '../../Table';
import { StyledTables } from '../style';
import { TableComponentProps } from '../types';

const _tables = [
  {
    name: 'Risk measure value',
    key: 'risk_measure_value',
    letter: 'A'
  },
  {
    name: 'Risk measure description',
    key: 'risk_measure_description',
    letter: 'B'
  }
];

const columnLables = {
  NET_EQTY_DELTA: {
    name: 'Net equity delta',
    order: 179
  },
  NET_CTY_DELTA: {
    name: 'Net commodity delta',
    order: 180
  },
  NET_FX_DELTA: {
    name: 'Net FX delta',
    order: 181
  }
};

export function MeasureRisk({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    tables,
    columns: columns,
    onChange: onChange
  } = useSplitedTable({
    data: funds[currentDataKey]?.fund_data?.MARKET_RISK_MEASURE,
    onChangeFund,
    schema: schema.MARKET_RISK_MEASURE,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.MARKET_RISK_MEASURE?.field_names || [],
    isMultiFunds,
    funds,
    tables: _tables,
    columnLables,
    tableName: 'MARKET_RISK_MEASURE',
    filderedFieldName: 'risk_measure_type'
  });

  return (
    <StyledTables id="fca-reporttables-measure-risk-group">
      {tables.map((rows, index) => (
        <Table
          id={`fca-reporttables-measure-risk-table-${index + 1}`}
          key={index + 'MARKET_RISK_MEASURE'}
          handleChanges={onChange}
          columns={columns}
          rows={rows}
          stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
        />
      ))}
    </StyledTables>
  );
}
